<template>
  <div class="admin-form">
    <label class="lbl-text">{{label}}</label>
    <input v-model="inputVal" v-maska data-maska="###.###.###-##" class="gui-input" placeholder="000.000.000-00" required>
  </div>
</template>

<script>
import { vMaska } from 'maska'

export default {
  props: ["value", "label"],
  directives: { maska: vMaska },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>
